import React from "react";
import HamburgerMenu from "./HamburgerMenu";
import { Link } from "react-router-dom";

function MobileNav({ isMobileMenuOpen, setMobileMenuOpen, toggleMobileMenu, isScrolled}) {
  return (
    <div
    className={`fixed top-0 right-0 h-full w-full transition-all duration-500 z-20 bg-gray-900/30 backdrop-blur-md md:hidden transform pt-16 ${
      isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
    }`}
    >
      <div className={`z-50 absolute z-50 duration-500 ${isScrolled ? "top-4" : "top-8"} right-4`}>
      <HamburgerMenu isMobileMenuOpen={isMobileMenuOpen} toggleMobileMenu={toggleMobileMenu}/>
      </div>
      <div className="flex items-center justify-center h-full">
      <ul className="flex flex-col space-y-6 p-6 text-white">
      <li>
          <Link
            to="/"
            className="block hover:text-gray-300 font-bold text-3xl text-center p-8"
            onClick={() => setMobileMenuOpen(false)}
          >
            Home
          </Link>
        </li>
        <li>
          <Link
            to="about"
            className="block hover:text-gray-300 font-bold text-3xl text-center p-8"
            onClick={() => setMobileMenuOpen(false)}
          >
            About
          </Link>
        </li>
        <li>
          <Link
            to="projects"
            className="block hover:text-gray-300 font-bold text-3xl text-center p-8"
            onClick={() => setMobileMenuOpen(false)}
          >
            Projects
          </Link>
        </li>
        <li>
          <Link
            to="contact"
            className="block hover:text-gray-300 font-bold text-3xl text-center p-8"
            onClick={() => setMobileMenuOpen(false)}
          >
            Contact
          </Link>
        </li>
      </ul>
      </div>
    </div>
  );
}

export default MobileNav;
